import { api } from "@api/api";
import { Catalog } from "@modules/catalogs/types";
import { CatalogFormValues } from "@modules/catalogs/validations";

export async function editCatalogService(id: string, data: Partial<CatalogFormValues>): Promise<Catalog> {
  const { data: catalog } = await api.patch<Catalog>(`v1/plan_admin/${id}/`, data);

  return catalog;
}
